import React, { useState, useRef, useEffect } from "react";
import "./AgentRegister.css";
import NavbarComponent from "../../components/navbar/NavbarComponent";
import { Link, useNavigate } from "react-router-dom";
import { API } from "../../constants/Api";
import { toast } from "react-toastify";
import Select from "react-select";
import { BorderAllRounded, Height } from "@mui/icons-material";
import { fontFamily, fontSize, padding, textAlign } from "@mui/system";
import zIndex from "@mui/material/styles/zIndex";
import { Button, Flex, Modal } from "antd";
import Meta from "../../components/Meta";
function AgentRegister() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("login");
  const [agree, setAgree] = useState(false);
  const verifyRef = useRef(null);
  const registerRef = useRef(null);
  const selectRef = useRef(null);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [agentzipCode, setCode] = useState([]);
  const [agentzipCode2, setCode2] = useState([]);
  const [phonenumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [image, setImage] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailForVerify, setEmailForVerify] = useState("");
  const [otp, setOtp] = useState("");
  const [emailLogin, setEmailLogin] = useState("");
  const [passwordLogin, setPasswordLogin] = useState("");
  const [file, setFile] = useState(null);
  const [options, setOptions] = useState([]);
  const [options2, setOptions2] = useState([
    {
      label: "California",
      value: "California",
    },
  ]);
  const [mlsNumber, setMlsNumber] = useState("");
  const [singInHeading, setHeading] = useState(
    "Welcome Back to Deal Direct Homes"
  );
  const agentId = localStorage.getItem("agentId");

  const token = localStorage.getItem("token");

  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);
  const [selectedOption, setSelectedOption] = React.useState("");

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    setIsDropdownOpen(false);
  };

  useEffect(() => {
    if (token) {
      if (agentId) {
        navigate("/agent-auth/profile");
      }
    }
  }, [token]);
  const handleChangeTab = () => {
    switch (activeTab) {
      case "register":
        return setActiveTab("login");
      case "login":
        return setActiveTab("register");
      default:
        return setActiveTab("register");
    }
  };

  useEffect(() => {
    if (activeTab === "register") {
      if (verifyRef) {
        verifyRef.current.style.display = "none";
      }
    }
  }, [activeTab]);

  useEffect(() => {
    const getOptions = async () => {
      try {
        const response = await fetch(`${API}/auth/role-check/available-for-showing-agents`);
        const json = await response.json();

        if (response.ok) {
          const aqdas = await json.zipCodes.map((data) => ({
            label: data.zipCode,
            value: data.zipCode,
          }));
          if (aqdas) {
            setOptions(aqdas);
          }
        }
      } catch (error) {
        toast.error(error.message);
      }
    };

    getOptions();
  }, []);

  const colorStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: "#252525",
      borderColor: state.isFocused ? "#252525" : "#252525",
      boxShadow: state.isFocused ? "none" : "none",
      borderRadius: "20px", // Adjust the border-radius as needed
      minHeight: "66px", // Increase the height
      padding: "10px",
      "&:hover": {
        borderColor: "#252525",
      },
      "&:focus": {
        borderColor: "#252525",
      },
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#24A97B"
        : state.isFocused
          ? "#252525"
          : "#252525",
      borderRadius: "20px",

      color: state.isSelected ? "black" : "white",
      "&:hover": {
        backgroundColor: "#000000",
      },
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "#252525",
      border: "1px solid #252525",
      borderRadius: "20px", // Add border-radius to the dropdown menu
      fontFamily: "Degular-Light",
      fontSize: "14px",
      padding: "10px",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#ffffff",
      fontFamily: "Degular-Light",
      fontSize: "14px",
      opacity: "0.7",
    }),
    singleValue: (base) => ({
      ...base,
      color: "#ffffff",
      fontFamily: "Degular-Light",
      fontSize: "14px",
    }),
    input: (base) => ({
      ...base,
      color: "#ffffff",
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#000000",
      fontFamily: "Degular-Light",
      fontSize: "14px",
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "#ffffff",
      fontFamily: "Degular-Light",
      fontSize: "14px",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "#ffffff",
      "&:hover": {
        backgroundColor: "red",
        color: "white",
      },
    }),
  };

  const handleZipChange = (selectedOption) => {
    setCode(selectedOption ? selectedOption.map((aqdas) => aqdas.value) : []);
  };
  const handleZipChange2 = (selectedOption2) => {
    setCode2(
      selectedOption2 ? selectedOption2.map((aqdas) => aqdas.value) : []
    );
  };
  function loginValidation() {
    if (emailLogin.length < 1) {
      toast.error("Email is required");
      return false;
    }
    if (passwordLogin.length < 1) {
      toast.error("Password is required");
      return false;
    }

    return true;
  }
  function otpValidation() {
    if (otp.length < 1) {
      toast.error("OTP is required");
      return false;
    }
    if (!agree) {
      toast.error("You must agree first");
      return false;
    }

    return true;
  }
  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
  function validation() {
    if (name.length < 1) {
      toast.error("Name is required");
      return false;
    }

    if (email.length < 1) {
      toast.error("Email is required");
      return false;
    } else {
      if (!isValidEmail(email)) {
        toast.error("Please enter valid email");
        return false;
      }
    }

    if (selectedOption.length < 1) {
      toast.error("Vendor Type is required");
      return false;
    }
    if (phonenumber.length < 1) {
      toast.error("Phone number required");
      return false;
    }
    if (phonenumber.length > 10) {
      toast.error("Phone length should be under 11");
      return false;
    }
    if (password.length < 1) {
      toast.error("Password is required");
      return false;
    }
    if (selectedOption === "Listing Agent") {
      if (mlsNumber.length < 1) {
        toast.error("Realtor License # required");
        return false;
      }
      if (agentzipCode2.length < 1) {
        toast.error("State is required");
        return false;
      }
    }
    if (selectedOption === "Showing Agent") {
      if (agentzipCode.length < 1) {
        toast.error("please select atleast 1 zipCode");
        return false;
      }
    }
    if (!agree) {
      toast.error("You must agree first");
      return false;
    }

    return true;
  }

  const handleSignUp = async (e) => {
    e.preventDefault();

    const validate = await validation();

    if (validate) {
      const formData = new FormData();

      if (selectedOption === "Listing Agent") {
        formData.append("mlsNumber", mlsNumber);
        formData.append("state", agentzipCode2[0]);
      }
      if (selectedOption === "Showing Agent") {
        formData.append("agentzipCode", agentzipCode);
      }
      formData.append("agentName", name);
      formData.append("agentEmail", email);
      formData.append("agentPhone", phonenumber);
      formData.append("password", password);

      formData.append("agentVendorType", selectedOption);
      formData.append("file", file);
      setLoading(true);
      const toastLoading = await toast.loading("Creating new agent...");
      try {
        const response = await fetch(`${API}/agents/register-agent`, {
          method: "POST",
          body: formData,
        });
        const json = await response.json();
        if (response.ok) {
          toast.dismiss(toastLoading);
          toast.success("Please check your email to verify your account");
          setLoading(false);
          // setEmailForVerify(json.agent.agentEmail);

          // if (registerRef) {
          //   registerRef.current.style.display = "none";
          // }
          // if (verifyRef) {
          //   verifyRef.current.style.display = "block";
          // }
          setName("");
          setEmail("");
          setPassword("");
          setPhoneNumber("");
          setOtp("");
          setHeading("Once verified, you can login");

          handleChangeTab();
        } else {
          setLoading(false);
          toast.dismiss(toastLoading);
          toast.error(json.message);
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        toast.dismiss(toastLoading);
        setLoading(false);
      }
    }
  };
  const handleVerify = async (e) => {
    e.preventDefault();

    const validate = await otpValidation();

    if (validate) {
      const data = {
        agentEmail: emailForVerify,
        otp,
      };
      try {
        setLoading(true);
        const toastLoading = await toast.loading("OTP verifying...");
        const response = await fetch(`${API}/agents/verify-agent-otp`, {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
          },
        });
        const json = await response.json();
        if (response.ok) {
          toast.dismiss(toastLoading);
          toast.success("User verified successfully");
          setLoading(false);
          setName("");
          setEmail("");
          setPassword("");
          setPhoneNumber("");
          setOtp("");
          setHeading("You've created account, now login");
          handleChangeTab();
        } else {
          setLoading(false);
          toast.dismiss(toastLoading);
          toast.error(json.message);
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    }
  };
  const handleLogin = async (e, myType) => {
    e.preventDefault();

    const validate = await loginValidation();

    if (validate) {
      const data = {
        agentEmail: emailLogin,
        agentPassword: passwordLogin,
        agentVendorType: myType,
      };
      setLoading(true);
      const toastLoading = toast.loading("Signing in...");
      try {
        const response = await fetch(`${API}/agents/login-agent`, {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
          },
        });
        const json = await response.json();
        if (response.ok) {
          toast.dismiss(toastLoading);
          toast.success("Signed in successfully");
          setLoading(false);

          await localStorage.removeItem("token");
          await localStorage.removeItem("laId");
          await localStorage.removeItem("laEmail");
          await localStorage.removeItem("laName");
          await localStorage.removeItem("laPhone");
          await localStorage.removeItem("laState");
          await localStorage.removeItem("token");
          await localStorage.removeItem("agentId");
          await localStorage.removeItem("agentEmail");
          await localStorage.removeItem("agentName");
          await localStorage.removeItem("agentPhone");

          await localStorage.removeItem("agentVendorType");
          await localStorage.removeItem("agentState");
          await localStorage.removeItem("agentZipCode");

          await localStorage.removeItem("token");
          await localStorage.removeItem("userId");
          await localStorage.removeItem("userEmail");
          await localStorage.removeItem("userName");
          await localStorage.removeItem("userPhone");
          await localStorage.removeItem("userZipCode");

          await localStorage.removeItem("token");
          await localStorage.removeItem("advertiserId");
          await localStorage.removeItem("email");
          await localStorage.removeItem("name");
          await localStorage.removeItem("phone");
          await localStorage.removeItem("zipCode");

          await localStorage.removeItem("token");
          await localStorage.removeItem("adminId");
          await localStorage.removeItem("adminEmail");
          await localStorage.removeItem("adminName");
          await localStorage.removeItem("adminPhone");
          await localStorage.removeItem("token");
          await localStorage.removeItem("addhypeId");
          await localStorage.removeItem("addhypeEmail");
          await localStorage.removeItem("addhypeName");
          await localStorage.removeItem("addhypePhone");

          localStorage.setItem("token", json.token);
          localStorage.setItem("agentId", json.agent._id);
          localStorage.setItem("agentEmail", json.agent.agentEmail);
          localStorage.setItem("agentName", json.agent.agentName);
          localStorage.setItem("agentPhone", json.agent.agentPhone);
          localStorage.setItem("agentZipCode", json.agent.agentzipCode);
          if (json.agent.agentVendorType === "Showing Agent") {
            localStorage.setItem(
              "agentZipCode",
              JSON.stringify(json.agent.agentzipCode)
            );
          }
          localStorage.setItem(
            "agentState",
            json.agent.state ? json.agent.state : ""
          );
          localStorage.setItem("agentVendorType", json.agent.agentVendorType);
          navigate("/agent-auth/profile");
          setEmailLogin("");
          setPasswordLogin("");
        } else {
          setLoading(false);
          toast.dismiss(toastLoading);
          toast.error(json.message);
        }
      } catch (error) {
        toast.dismiss(toastLoading);
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    }
  };

  const [openResponsive, setOpenResponsive] = useState(false);

  const openTerms = () => {
    setOpenResponsive(true);
  };

  const handleForgot = (e) => {
    e.preventDefault();
    navigate("/forgot-password", { state: { type: "agent" } });
  };
     const [isMobile, setIsMobile] = useState(false);
      useEffect(() => {
        const handleResize = () => {
          setIsMobile(window.innerWidth <= 600);
        };
    
        handleResize();
    
        window.addEventListener("resize", handleResize);
        return () => {
          window.removeEventListener("resize", handleResize);
        };
      }, []);
  return (
    <>
      <Meta
        title="Agent Sign Up | DDH Agent (Listing/Showing)"
        description="Join Deal Direct Homes Agent to connect with buyers and sellers in your area and grow your business."
      />
      <div className="agent-register-section">
        <NavbarComponent />
        {activeTab === "register" ? (
          <div className="container-fluid agent-register-container px-0">
            <div className="row px-0 mx-0">
              <div className="col-lg-6 agent-register-form-conatiner">
                <span ref={registerRef} className="w-100">
                  <h2 className="agent-register-heading">Join as an Agent</h2>
                  <div className="my-2">
                    <button
                      className="btn agent-login-register-tab"
                      onClick={handleChangeTab}
                    >
                      Sign In
                    </button>
                    <button className="btn agent-login-register-tab ms-3 active-agent-login-register-tab">
                      Register
                    </button>
                  </div>
                  <form className="agent-register-form">
                    <input
                      type="text"
                      className="form-control agent-register-input-field"
                      id="exampleInputEmail1"
                      placeholder="Full Name"
                      aria-describedby="emailHelp"
                      onChange={(e) => setName(e.target.value)}
                    />

                    <input
                      type="email"
                      className="form-control agent-register-input-field"
                      id="exampleInputPassword1"
                      placeholder="Email"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                            {isMobile ? (
                      <input
                        type="tel"
                        className="form-control agent-register-input-field"
                        id="userPhone"
                        placeholder="Phone number"
                        value={`+1 ${phonenumber}`} // Display "+1" prefix
                        onChange={(e) => {
                          // Remove "+1" and any extra spaces before saving to state
                          const rawNumber = e.target.value
                            .replace(/^\+1\s*/, "")
                            .slice(0, 10);
                          setPhoneNumber(rawNumber);
                        }}
                      />
                    ) : (
                      <div className="agent-register-phone-number-group">
                        <button disabled className="agent-register-phone-code">
                          +1
                        </button>
                        <input
                          type="number"
                          className="form-control agent-register-phone-field"
                          id="exampleInputPassword1"
                          placeholder="Phone Number"
                          maxLength="10"
                          min="0"
                          max="9999999999"
                          pattern="\d*"
                          onChange={(e) => {
                            const value = e.target.value
                              .replace(/\D/g, "")
                              .slice(0, 10);
                            setPhoneNumber(value);
                            e.target.value = value;
                          }}
                        />
                      </div>
                    )}

                    <input
                      type="password"
                      className={`form-control agent-register-input-field ${isMobile ? "" : "pass-input"}`}
                      id="exampleInputPassword1"
                      placeholder="Password"
                      onChange={(e) => setPassword(e.target.value)}
                    />

                    <hr
                      className="text-white agent-register-devider-1"
                      style={{ opacity: "0.1" }}
                    />
                    {/* <input
                    type="number"
                    className="form-control agent-register-input-field"
                    id="exampleInputPassword1"
                    placeholder="Zip Code"
                    onChange={(e) => setCode(e.target.value)}
                  /> */}
                    <div className="custom-dropdown">
                      <div
                        className="dropdown-header-agent"
                        // onBlur={()=>setIsDropdownOpen(false)}
                        onClick={toggleDropdown}
                        role="button"
                        tabIndex={0}
                      >
                        {selectedOption || "Vendor Type"}
                        <img
                          src="/img/faq-icon-2.svg"
                          className="me-0"
                          alt=""
                        />
                      </div>
                      {isDropdownOpen && (
                        <ul className="dropdown-options-agent">
                          <li
                            onClick={() => handleOptionSelect("Showing Agent")}
                          >
                            Showing Agent
                          </li>
                          <li
                            onClick={() => handleOptionSelect("Listing Agent")}
                          >
                            Listing Agent
                          </li>
                          {/* <li
                          onClick={() =>
                            handleOptionSelect("Transaction Coordinator")
                          }
                        >
                          Transaction Coordinator
                        </li> */}
                          {/* <li
                          onClick={() =>
                            handleOptionSelect("LO Agent (Loan Officer)")
                          }
                        >
                          LO Agent (Loan Officer)
                        </li>
                        <li
                          onClick={() =>
                            handleOptionSelect("Transaction Coordinator")
                          }
                        >
                          Transaction Coordinator
                        </li>
                        <li onClick={() => handleOptionSelect("Lending Agent")}>
                          Lending Agent
                        </li> */}
                        </ul>
                      )}
                    </div>
                    {selectedOption === "Showing Agent" ? (
                      <>
                        <div onClick={() => setIsDropdownOpen(false)}>
                          <Select
                            isMulti
                            name="colors"
                            styles={colorStyles}
                            options={options}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder="Choose Zip Codes..."
                            onChange={handleZipChange}
                          />
                        </div>
                        <div className="mb-3 form-check agent-register-verify-check-group px-0">
                          <img
                            role="button"
                            onClick={() => setAgree(!agree)}
                            src={`${agree ? "/img/checked.svg" : "/img/uncheck.svg"}`}
                            className="img-fluid"
                            alt=""
                          />

                          <label
                            className="form-check-label ms-3"
                            htmlFor="exampleCheck1"
                          >
                            I agree to the{" "}
                            <b
                              className="text-white"
                              onClick={openTerms}
                              role="button"
                            >
                              Terms and Conditions
                            </b>{" "}
                            set by DDH
                          </label>
                          <Modal
                            style={{ padding: "0px", margin: "0px" }}
                            centered
                            open={openResponsive}
                            footer={null}
                            closable={false}
                            width={{
                              xs: "90%",
                              sm: "80%",
                              md: "65%",
                              lg: "60%",
                              xl: "60%",
                              xxl: "60%",
                            }}
                          >
                            <div className="container-fluid pop-up-terms">
                              <img
                                src="/img/pop-up-close.svg"
                                className="img-fluid pop-up-close"
                                onClick={() => setOpenResponsive(false)}
                                role="button"
                                alt=""
                              />
                              <div className="container-fluid">
                                <div className="row">
                                  <div className="col-12 agreement-1st-container">
                                    {selectedOption === "Listing Agent" ? (
                                      <>
                                        <h2 className="agreement-heading">
                                          Listing Agent Agreement
                                        </h2>
                                        <p className="agreement-paragraph">
                                          By clicking the agree button, you
                                          agree to the following: This agreement
                                          is between Deal Direct Home LLC,
                                          hereinto referred to as DDH, and the
                                          Listing Agent, hereinto referred to as
                                          Agent. All Agents must maintain a
                                          valid DRE License to buy leads from
                                          DDH. The Agent wishes to buy Showing
                                          Leads with the opportunity to show
                                          their listed property and convert
                                          Buyers into full representation. Leads
                                          that are distributed by DDH will not
                                          pay for Agents Commission unless
                                          explicitly disclosed and consulted in
                                          signing of Buyer Agent Agreement.
                                          <ol>
                                            <li className="mt-2">
                                              Agents with “Listing Agent Status”
                                              on properties that the DDH
                                              unrepresented buyer identifies for
                                              purchase will have the opportunity
                                              to buy lead. Purchase of lead does
                                              not exclude Agent from Double
                                              Ending sale if Buy Side commission
                                              is not paid by Lead.
                                            </li>
                                            <li className="mt-2">
                                              All Agents must conduct themselves
                                              according to the most recent Code
                                              Of Ethics and Standards of
                                              Practice produced by NAR.
                                            </li>
                                            <li className="mt-2">
                                              Leads may not be transferred to
                                              any other agent without the
                                              written consent of DDH.
                                            </li>
                                            <li className="mt-2">
                                              Upon accepting a lead, Agents
                                              Payment information on file will
                                              be billed immediately.
                                            </li>
                                            <li className="mt-2">
                                              Payment information on Agents
                                              Profile must be current and
                                              accurate at all times.
                                            </li>
                                            <li className="mt-2">
                                              Agents must have a current and up
                                              to date Profile account to receive
                                              leads, including Valid Real Estate
                                              License.
                                            </li>
                                            <li className="mt-2">
                                              Leads are Self Represented with
                                              client information and
                                              pre-approved. Cost: Listing Agent
                                              Lead $349.00.
                                            </li>
                                            <li className="mt-2">
                                              The Cost of Listing Agent Lead
                                              subject to change at any time.
                                            </li>
                                          </ol>
                                          *Leads are distributed once Agent
                                          accepts lead and account is billed.
                                        </p>
                                      </>
                                    ) : (
                                      <>
                                        <h2 className="agreement-heading">
                                          Showing Agent Agreement
                                        </h2>
                                        <p className="agreement-paragraph">
                                          By clicking the agree button, you
                                          agree to the following: This agreement
                                          is between Deal Direct Home LLC,
                                          hereinto referred to as DDH, and the
                                          Showing Agent, hereinto referred to as
                                          Agent. All Showing Agents must
                                          maintain a valid DRE License to buy
                                          leads from DDH. The Showing Agent
                                          wishes to buy Showing Leads with the
                                          opportunity to show property and
                                          convert Buyers into full
                                          representation. Buyer Leads that are
                                          distributed by DDH will not pay for
                                          Agents Commission unless explicitly
                                          disclosed and consulted in signing of
                                          Buyer Agent Agreement.
                                        </p>
                                        <h2 className="agreement-heading">
                                          DDH Tier I
                                        </h2>
                                        <h2 className="agreement-heading">
                                          Showing Lead with Property Identified
                                          and Financing
                                        </h2>
                                        <p className="agreement-paragraph">
                                          <ol>
                                            <li className="mt-2">
                                              Showing Lead with Property
                                              Identified and Financing
                                            </li>
                                            <li className="mt-2">
                                              All Showing Agents’ leads are
                                              distributed from the Zip Codes
                                              each agent has signed up for. All
                                              Zip codes are limited membership.
                                              Application to be a DDH Showing
                                              Agent is NOT guaranteed and will
                                              be Vetted and on a First Come
                                              Basis.
                                            </li>
                                            <li className="mt-2">
                                              All Agents must conduct themselves
                                              according to the most recent Code
                                              Of Ethics and Standards of
                                              Practice produced by NAR.
                                            </li>
                                            <li className="mt-2">
                                              All Agents are responsible for
                                              collection of their Showing Fee.
                                              Agents are to ensure compliance
                                              with their Broker Contract for
                                              collection.
                                            </li>
                                            <li className="mt-2">
                                              Leads may not be transferred to
                                              any other agent without the
                                              written consent of DDH.
                                            </li>
                                            <li className="mt-2">
                                              Agents may NOT substitute another
                                              agent to show property on their
                                              behalf.
                                            </li>
                                            <li className="mt-2">
                                              Upon accepting a lead, Agents
                                              Payment information on file will
                                              be billed immediately.
                                            </li>
                                            <li className="mt-2">
                                              Payment information on Agents
                                              Profile must be current and
                                              accurate at all times.
                                            </li>
                                            <li className="mt-2">
                                              Agents must have a current and up
                                              to date Profile account to receive
                                              leads.
                                            </li>
                                            <li className="mt-2">
                                              Agents may not charge more than
                                              $99.00 for a single showing fee.
                                            </li>
                                            <li className="mt-2">
                                              Standard Showing Leads are
                                              pre-approved and property address
                                              provided; Cost $29.00. The Cost of
                                              Tier I and Tier II Showing Agent
                                              Lead are subject to change at any
                                              time.
                                            </li>
                                            <li className="mt-2">
                                              Agents are responsible for the
                                              collection of the fees charged.
                                              Therefore, each Agent must have
                                              their own Point of Sale method
                                              (POS - i.e. Squarespace, PayPal,
                                              etc.).
                                            </li>
                                          </ol>
                                          *All Leads are distributed once Agent
                                          accepts lead and account is billed and
                                          paid. Best Practices: Agent charges
                                          $99.00 for the first three showings,
                                          $49.00 for each additional showing or
                                          Agent charges $49.00 for a single
                                          showing.
                                        </p>

                                        <h2 className="agreement-heading">
                                          DDH Tier II
                                        </h2>
                                        <h2 className="agreement-heading">
                                          Showing Leads with No Financing
                                        </h2>
                                        <p className="agreement-paragraph">
                                          Additional Lead Option with no
                                          pre-approval and may or may not have
                                          an identified property. They have
                                          simply demonstrated interest in buying
                                          property in a designated zip code.{" "}
                                          <ol>
                                            <li className="mt-2">
                                              All Agents must conduct themselves
                                              according to the most recent Code
                                              Of Ethics and Standards of
                                              Practice produced by NAR.
                                            </li>
                                            <li className="mt-2">
                                              All Agents are responsible for
                                              collection of their Showing Fee.
                                              Agents are to ensure compliance
                                              with their Broker Contract for
                                              collection.
                                            </li>
                                            <li className="mt-2">
                                              Leads may not be transferred to
                                              any other agent without the
                                              written consent of DDH. Agents may
                                              NOT substitute another agent to
                                              show property on their behalf.
                                            </li>
                                            <li className="mt-2">
                                              Upon accepting a lead, Agents
                                              Payment information on file will
                                              be billed immediately. Payment
                                              information on Agents Profile must
                                              be current and accurate at all
                                              times.
                                            </li>
                                            <li className="mt-2">
                                              Agents must have a current and up
                                              to date Profile account to receive
                                              leads.
                                            </li>
                                          </ol>
                                          Agents may not charge more than $99.00
                                          for a single showing fee. Lead Cost
                                          Tier II, $ 9.00. The Cost of Tier II
                                          Showing Agent Leads are subject to
                                          change at any time. Agents are
                                          responsible for the collection of the
                                          fees charged. Therefore, each Agent
                                          must have their own Point of Sale
                                          method (POS - i.e.
                                          Squarespace, PayPal, etc.)
                                        </p>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Modal>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                    {selectedOption === "Listing Agent" ? (
                      <div onClick={() => setIsDropdownOpen(false)}>
                        <Select
                          isMulti
                          name="colors"
                          styles={colorStyles}
                          options={options2}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          placeholder="Choose State..."
                          onChange={handleZipChange2}
                        />
                      </div>
                    ) : (
                      <></>
                    )}

                    {selectedOption === "Listing Agent" ? (
                      <>
                        <input
                          type="text"
                          className="form-control agent-register-input-field"
                          id="exampleInputEmail1"
                          placeholder="Realtor License #"
                          aria-describedby="emailHelp"
                          onChange={(e) => setMlsNumber(e.target.value)}
                        />
                        <div className="mb-3 form-check agent-register-verify-check-group px-0">
                          <img
                            role="button"
                            onClick={() => setAgree(!agree)}
                            src={`${agree ? "/img/checked.svg" : "/img/uncheck.svg"}`}
                            className="img-fluid"
                            alt=""
                          />

                          <label
                            className="form-check-label ms-3"
                            htmlFor="exampleCheck1"
                          >
                            I agree to the{" "}
                            <b
                              className="text-white"
                              onClick={openTerms}
                              role="button"
                            >
                              Terms and Conditions
                            </b>{" "}
                            set by DDH
                          </label>
                          <Modal
                            style={{ padding: "0px", margin: "0px" }}
                            centered
                            open={openResponsive}
                            footer={null}
                            closable={false}
                            width={{
                              xs: "90%",
                              sm: "80%",
                              md: "65%",
                              lg: "60%",
                              xl: "60%",
                              xxl: "60%",
                            }}
                          >
                            <div className="container-fluid pop-up-terms">
                              <img
                                src="/img/pop-up-close.svg"
                                className="img-fluid pop-up-close"
                                onClick={() => setOpenResponsive(false)}
                                role="button"
                                alt=""
                              />
                              <div className="container-fluid">
                                <div className="row">
                                  <div className="col-12 agreement-1st-container">
                                    {selectedOption === "Listing Agent" ? (
                                      <>
                                        <h2 className="agreement-heading">
                                          Listing Agent Agreement
                                        </h2>
                                        <p className="agreement-paragraph">
                                          By clicking the agree button, you
                                          agree to the following: This agreement
                                          is between Deal Direct Home LLC,
                                          hereinto referred to as DDH, and the
                                          Listing Agent, hereinto referred to as
                                          Agent. All Agents must maintain a
                                          valid DRE License to buy leads from
                                          DDH. The Agent wishes to buy Showing
                                          Leads with the opportunity to show
                                          their listed property and convert
                                          Buyers into full representation. Leads
                                          that are distributed by DDH will not
                                          pay for Agents Commission unless
                                          explicitly disclosed and consulted in
                                          signing of Buyer Agent Agreement.
                                          <ol>
                                            <li className="mt-2">
                                              Agents with “Listing Agent Status”
                                              on properties that the DDH
                                              unrepresented buyer identifies for
                                              purchase will have the opportunity
                                              to buy lead. Purchase of lead does
                                              not exclude Agent from Double
                                              Ending sale if Buy Side commission
                                              is not paid by Lead.
                                            </li>
                                            <li className="mt-2">
                                              All Agents must conduct themselves
                                              according to the most recent Code
                                              Of Ethics and Standards of
                                              Practice produced by NAR.
                                            </li>
                                            <li className="mt-2">
                                              Leads may not be transferred to
                                              any other agent without the
                                              written consent of DDH.
                                            </li>
                                            <li className="mt-2">
                                              Upon accepting a lead, Agents
                                              Payment information on file will
                                              be billed immediately.
                                            </li>
                                            <li className="mt-2">
                                              Payment information on Agents
                                              Profile must be current and
                                              accurate at all times.
                                            </li>
                                            <li className="mt-2">
                                              Agents must have a current and up
                                              to date Profile account to receive
                                              leads, including Valid Real Estate
                                              License.
                                            </li>
                                            <li className="mt-2">
                                              Leads are Self Represented with
                                              client information and
                                              pre-approved. Cost: Listing Agent
                                              Lead $349.00.
                                            </li>
                                            <li className="mt-2">
                                              The Cost of Listing Agent Lead
                                              subject to change at any time.
                                            </li>
                                          </ol>
                                          *Leads are distributed once Agent
                                          accepts lead and account is billed.
                                        </p>
                                      </>
                                    ) : (
                                      <>
                                        <h2 className="agreement-heading">
                                          Showing Agent Agreement
                                        </h2>
                                        <p className="agreement-paragraph">
                                          By clicking the agree button, you
                                          agree to the following: This agreement
                                          is between Deal Direct Home LLC,
                                          hereinto referred to as DDH, and the
                                          Showing Agent, hereinto referred to as
                                          Agent. All Showing Agents must
                                          maintain a valid DRE License to buy
                                          leads from DDH. The Showing Agent
                                          wishes to buy Showing Leads with the
                                          opportunity to show property and
                                          convert Buyers into full
                                          representation. Buyer Leads that are
                                          distributed by DDH will not pay for
                                          Agents Commission unless explicitly
                                          disclosed and consulted in signing of
                                          Buyer Agent Agreement.
                                        </p>
                                        <h2 className="agreement-heading">
                                          DDH Tier I
                                        </h2>
                                        <h2 className="agreement-heading">
                                          Showing Lead with Property Identified
                                          and Financing
                                        </h2>
                                        <p className="agreement-paragraph">
                                          <ol>
                                            <li className="mt-2">
                                              Showing Lead with Property
                                              Identified and Financing
                                            </li>
                                            <li className="mt-2">
                                              All Showing Agents’ leads are
                                              distributed from the Zip Codes
                                              each agent has signed up for. All
                                              Zip codes are limited membership.
                                              Application to be a DDH Showing
                                              Agent is NOT guaranteed and will
                                              be Vetted and on a First Come
                                              Basis.
                                            </li>
                                            <li className="mt-2">
                                              All Agents must conduct themselves
                                              according to the most recent Code
                                              Of Ethics and Standards of
                                              Practice produced by NAR.
                                            </li>
                                            <li className="mt-2">
                                              All Agents are responsible for
                                              collection of their Showing Fee.
                                              Agents are to ensure compliance
                                              with their Broker Contract for
                                              collection.
                                            </li>
                                            <li className="mt-2">
                                              Leads may not be transferred to
                                              any other agent without the
                                              written consent of DDH.
                                            </li>
                                            <li className="mt-2">
                                              Agents may NOT substitute another
                                              agent to show property on their
                                              behalf.
                                            </li>
                                            <li className="mt-2">
                                              Upon accepting a lead, Agents
                                              Payment information on file will
                                              be billed immediately.
                                            </li>
                                            <li className="mt-2">
                                              Payment information on Agents
                                              Profile must be current and
                                              accurate at all times.
                                            </li>
                                            <li className="mt-2">
                                              Agents must have a current and up
                                              to date Profile account to receive
                                              leads.
                                            </li>
                                            <li className="mt-2">
                                              Agents may not charge more than
                                              $99.00 for a single showing fee.
                                            </li>
                                            <li className="mt-2">
                                              Standard Showing Leads are
                                              pre-approved and property address
                                              provided; Cost $29.00. The Cost of
                                              Tier I and Tier II Showing Agent
                                              Lead are subject to change at any
                                              time.
                                            </li>
                                            <li className="mt-2">
                                              Agents are responsible for the
                                              collection of the fees charged.
                                              Therefore, each Agent must have
                                              their own Point of Sale method
                                              (POS - i.e. Squarespace, PayPal,
                                              etc.).
                                            </li>
                                          </ol>
                                          *All Leads are distributed once Agent
                                          accepts lead and account is billed and
                                          paid. Best Practices: Agent charges
                                          $99.00 for the first three showings,
                                          $49.00 for each additional showing or
                                          Agent charges $49.00 for a single
                                          showing.
                                        </p>

                                        <h2 className="agreement-heading">
                                          DDH Tier II
                                        </h2>
                                        <h2 className="agreement-heading">
                                          Showing Leads with No Financing
                                        </h2>
                                        <p className="agreement-paragraph">
                                          Additional Lead Option with no
                                          pre-approval and may or may not have
                                          an identified property. They have
                                          simply demonstrated interest in buying
                                          property in a designated zip code.{" "}
                                          <ol>
                                            <li className="mt-2">
                                              All Agents must conduct themselves
                                              according to the most recent Code
                                              Of Ethics and Standards of
                                              Practice produced by NAR.
                                            </li>
                                            <li className="mt-2">
                                              All Agents are responsible for
                                              collection of their Showing Fee.
                                              Agents are to ensure compliance
                                              with their Broker Contract for
                                              collection.
                                            </li>
                                            <li className="mt-2">
                                              Leads may not be transferred to
                                              any other agent without the
                                              written consent of DDH. Agents may
                                              NOT substitute another agent to
                                              show property on their behalf.
                                            </li>
                                            <li className="mt-2">
                                              Upon accepting a lead, Agents
                                              Payment information on file will
                                              be billed immediately. Payment
                                              information on Agents Profile must
                                              be current and accurate at all
                                              times.
                                            </li>
                                            <li className="mt-2">
                                              Agents must have a current and up
                                              to date Profile account to receive
                                              leads.
                                            </li>
                                          </ol>
                                          Agents may not charge more than $99.00
                                          for a single showing fee. Lead Cost
                                          Tier II, $ 9.00. The Cost of Tier II
                                          Showing Agent Leads are subject to
                                          change at any time. Agents are
                                          responsible for the collection of the
                                          fees charged. Therefore, each Agent
                                          must have their own Point of Sale
                                          method (POS - i.e.
                                          Squarespace, PayPal, etc.)
                                        </p>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Modal>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}

                    {loading ? (
                      <span className="btn agent-register-button">
                        Processing...
                      </span>
                    ) : (
                      <button
                        onClick={handleSignUp}
                        className="btn agent-register-button"
                      >
                        Sign Up
                      </button>
                    )}

                    {/* <img
                    src="/img/user-register-devider.svg"
                    className="img-fluid agent-register-devider"
                    alt=""
                  />
                  <button
                    type="button"
                    className="btn agent-register-google-button"
                  >
                    <img src="/img/google.png" alt="" /> Continue with Google
                  </button> */}
                  </form>
                </span>
                <span ref={verifyRef} className="w-100">
                  <h2 className="agent-register-heading code-veri-heading">
                    Verify Account
                  </h2>

                  <form className="agent-register-form code-veri-input">
                    <input
                      type="number"
                      className="form-control agent-register-input-field"
                      id="exampleInputEmail1"
                      placeholder="00 00"
                      aria-describedby="emailHelp"
                      onChange={(e) => setOtp(e.target.value)}
                    />

                    <label style={{ opacity: "0.8" }} className="code-label">
                      4 - Digit code has been sent to your phone number and
                      email.{" "}
                      {/* <Link className="text-white">Change Details</Link> */}
                    </label>

                    <label className="code-label" style={{ opacity: "0.7" }}>
                      By using Deal Direct Homes (DDH), you agree to these terms
                      and conditions. If you do not agree, please refrain from
                      using our services. DDH provides property listings and
                      connects agents with licensed real estate agents but does
                      not directly buy, sell, or broker real estate
                      transactions. While we strive to ensure the accuracy and
                      timeliness of information on our platform, we cannot
                      guarantee its completeness.
                    </label>

                    <div className="mb-3 form-check agent-register-verify-check-group px-0">
                      <img
                        role="button"
                        onClick={() => setAgree(!agree)}
                        src={`${agree ? "/img/checked.svg" : "/img/uncheck.svg"}`}
                        className="img-fluid"
                        alt=""
                      />

                      <label
                        className="form-check-label ms-3"
                        htmlFor="exampleCheck1"
                      >
                        I agree to the{" "}
                        <b
                          className="text-white"
                          onClick={openTerms}
                          role="button"
                        >
                          Terms and Conditions
                        </b>{" "}
                        set by DDH
                      </label>
                      <Modal
                        style={{ padding: "0px", margin: "0px" }}
                        centered
                        open={openResponsive}
                        footer={null}
                        closable={false}
                        width={{
                          xs: "90%",
                          sm: "80%",
                          md: "65%",
                          lg: "60%",
                          xl: "60%",
                          xxl: "60%",
                        }}
                      >
                        <div className="container-fluid pop-up-terms">
                          <img
                            src="/img/pop-up-close.svg"
                            className="img-fluid pop-up-close"
                            onClick={() => setOpenResponsive(false)}
                            role="button"
                            alt=""
                          />
                          <div className="container-fluid">
                            <div className="row">
                              <div className="col-12 agreement-1st-container">
                                {selectedOption === "Listing Agent" ? (
                                  <>
                                    <h2 className="agreement-heading">
                                      Listing Agent Agreement
                                    </h2>
                                    <p className="agreement-paragraph">
                                      By clicking the agree button, you agree to
                                      the following: This agreement is between
                                      Deal Direct Home LLC, hereinto referred to
                                      as DDH, and the Listing Agent, hereinto
                                      referred to as Agent. All Agents must
                                      maintain a valid DRE License to buy leads
                                      from DDH. The Agent wishes to buy Showing
                                      Leads with the opportunity to show their
                                      listed property and convert Buyers into
                                      full representation. Leads that are
                                      distributed by DDH will not pay for Agents
                                      Commission unless explicitly disclosed and
                                      consulted in signing of Buyer Agent
                                      Agreement.
                                      <ol>
                                        <li className="mt-2">
                                          Agents with “Listing Agent Status” on
                                          properties that the DDH unrepresented
                                          buyer identifies for purchase will
                                          have the opportunity to buy lead.
                                          Purchase of lead does not exclude
                                          Agent from Double Ending sale if Buy
                                          Side commission is not paid by Lead.
                                        </li>
                                        <li className="mt-2">
                                          All Agents must conduct themselves
                                          according to the most recent Code Of
                                          Ethics and Standards of Practice
                                          produced by NAR.
                                        </li>
                                        <li className="mt-2">
                                          Leads may not be transferred to any
                                          other agent without the written
                                          consent of DDH.
                                        </li>
                                        <li className="mt-2">
                                          Upon accepting a lead, Agents Payment
                                          information on file will be billed
                                          immediately.
                                        </li>
                                        <li className="mt-2">
                                          Payment information on Agents Profile
                                          must be current and accurate at all
                                          times.
                                        </li>
                                        <li className="mt-2">
                                          Agents must have a current and up to
                                          date Profile account to receive leads,
                                          including Valid Real Estate License.
                                        </li>
                                        <li className="mt-2">
                                          Leads are Self Represented with client
                                          information and pre-approved. Cost:
                                          Listing Agent Lead $349.00.
                                        </li>
                                        <li className="mt-2">
                                          The Cost of Listing Agent Lead subject
                                          to change at any time.
                                        </li>
                                      </ol>
                                      *Leads are distributed once Agent accepts
                                      lead and account is billed.
                                    </p>
                                  </>
                                ) : (
                                  <>
                                    <h2 className="agreement-heading">
                                      Showing Agent Agreement
                                    </h2>
                                    <p className="agreement-paragraph">
                                      By clicking the agree button, you agree to
                                      the following: This agreement is between
                                      Deal Direct Home LLC, hereinto referred to
                                      as DDH, and the Showing Agent, hereinto
                                      referred to as Agent. All Showing Agents
                                      must maintain a valid DRE License to buy
                                      leads from DDH. The Showing Agent wishes
                                      to buy Showing Leads with the opportunity
                                      to show property and convert Buyers into
                                      full representation. Buyer Leads that are
                                      distributed by DDH will not pay for Agents
                                      Commission unless explicitly disclosed and
                                      consulted in signing of Buyer Agent
                                      Agreement.
                                    </p>
                                    <h2 className="agreement-heading">
                                      DDH Tier I
                                    </h2>
                                    <h2 className="agreement-heading">
                                      Showing Lead with Property Identified and
                                      Financing
                                    </h2>
                                    <p className="agreement-paragraph">
                                      <ol>
                                        <li className="mt-2">
                                          Showing Lead with Property Identified
                                          and Financing
                                        </li>
                                        <li className="mt-2">
                                          All Showing Agents’ leads are
                                          distributed from the Zip Codes each
                                          agent has signed up for. All Zip codes
                                          are limited membership. Application to
                                          be a DDH Showing Agent is NOT
                                          guaranteed and will be Vetted and on a
                                          First Come Basis.
                                        </li>
                                        <li className="mt-2">
                                          All Agents must conduct themselves
                                          according to the most recent Code Of
                                          Ethics and Standards of Practice
                                          produced by NAR.
                                        </li>
                                        <li className="mt-2">
                                          All Agents are responsible for
                                          collection of their Showing Fee.
                                          Agents are to ensure compliance with
                                          their Broker Contract for collection.
                                        </li>
                                        <li className="mt-2">
                                          Leads may not be transferred to any
                                          other agent without the written
                                          consent of DDH.
                                        </li>
                                        <li className="mt-2">
                                          Agents may NOT substitute another
                                          agent to show property on their
                                          behalf.
                                        </li>
                                        <li className="mt-2">
                                          Upon accepting a lead, Agents Payment
                                          information on file will be billed
                                          immediately.
                                        </li>
                                        <li className="mt-2">
                                          Payment information on Agents Profile
                                          must be current and accurate at all
                                          times.
                                        </li>
                                        <li className="mt-2">
                                          Agents must have a current and up to
                                          date Profile account to receive leads.
                                        </li>
                                        <li className="mt-2">
                                          Agents may not charge more than $99.00
                                          for a single showing fee.
                                        </li>
                                        <li className="mt-2">
                                          Standard Showing Leads are
                                          pre-approved and property address
                                          provided; Cost $29.00. The Cost of
                                          Tier I and Tier II Showing Agent Lead
                                          are subject to change at any time.
                                        </li>
                                        <li className="mt-2">
                                          Agents are responsible for the
                                          collection of the fees charged.
                                          Therefore, each Agent must have their
                                          own Point of Sale method (POS - i.e.
                                          Squarespace, PayPal, etc.).
                                        </li>
                                      </ol>
                                      *All Leads are distributed once Agent
                                      accepts lead and account is billed and
                                      paid. Best Practices: Agent charges $99.00
                                      for the first three showings, $49.00 for
                                      each additional showing or Agent charges
                                      $49.00 for a single showing.
                                    </p>

                                    <h2 className="agreement-heading">
                                      DDH Tier II
                                    </h2>
                                    <h2 className="agreement-heading">
                                      Showing Leads with No Financing
                                    </h2>
                                    <p className="agreement-paragraph">
                                      Additional Lead Option with no
                                      pre-approval and may or may not have an
                                      identified property. They have simply
                                      demonstrated interest in buying property
                                      in a designated zip code.{" "}
                                      <ol>
                                        <li className="mt-2">
                                          All Agents must conduct themselves
                                          according to the most recent Code Of
                                          Ethics and Standards of Practice
                                          produced by NAR.
                                        </li>
                                        <li className="mt-2">
                                          All Agents are responsible for
                                          collection of their Showing Fee.
                                          Agents are to ensure compliance with
                                          their Broker Contract for collection.
                                        </li>
                                        <li className="mt-2">
                                          Leads may not be transferred to any
                                          other agent without the written
                                          consent of DDH. Agents may NOT
                                          substitute another agent to show
                                          property on their behalf.
                                        </li>
                                        <li className="mt-2">
                                          Upon accepting a lead, Agents Payment
                                          information on file will be billed
                                          immediately. Payment information on
                                          Agents Profile must be current and
                                          accurate at all times.
                                        </li>
                                        <li className="mt-2">
                                          Agents must have a current and up to
                                          date Profile account to receive leads.
                                        </li>
                                      </ol>
                                      Agents may not charge more than $99.00 for
                                      a single showing fee. Lead Cost Tier II, $
                                      9.00. The Cost of Tier II Showing Agent
                                      Leads are subject to change at any time.
                                      Agents are responsible for the collection
                                      of the fees charged. Therefore, each Agent
                                      must have their own Point of Sale method
                                      (POS - i.e. Squarespace, PayPal, etc.)
                                    </p>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </Modal>
                    </div>
                    {loading ? (
                      <span className="btn veri-button">Verifying...</span>
                    ) : (
                      <button
                        onClick={handleVerify}
                        className="btn veri-button"
                      >
                        Verify
                      </button>
                    )}
                  </form>
                </span>
              </div>
              <div className="col-lg-6 px-0 d-none d-lg-block">
                <div className="agent-register-image-conatiner"></div>
              </div>
            </div>
          </div>
        ) : (
          <div className="container-fluid agent-register-container px-0">
            <div className="row px-0 mx-0">
              <div className="col-lg-6 agent-register-form-conatiner">
                <h2 className="agent-register-heading">{singInHeading}</h2>
                <div className="my-2">
                  <button className="btn agent-login-register-tab active-agent-login-register-tab">
                    Sign In
                  </button>
                  <button
                    className="btn agent-login-register-tab ms-3"
                    onClick={handleChangeTab}
                  >
                    Register
                  </button>
                </div>
                <form className="agent-register-form">
                  <input
                    type="email"
                    className="form-control agent-register-input-field"
                    id="exampleInputPassword1"
                    placeholder="Email"
                    onChange={(e) => setEmailLogin(e.target.value)}
                    value={emailLogin}
                  />

                  <input
                    type="password"
                    className="form-control agent-register-input-field"
                    id="exampleInputPassword1"
                    placeholder="Password"
                    onChange={(e) => setPasswordLogin(e.target.value)}
                    value={passwordLogin}
                  />
                  <p
                    onClick={handleForgot}
                    style={{ cursor: "pointer", lineHeight: "1px" }}
                    className="forgot-password-button mt-4"
                  >
                    Forgot Password?
                  </p>
                  <button
                    onClick={(e) => handleLogin(e, "Showing Agent")}
                    className="btn agent-register-button"
                  >
                    Sign In As Showing Agent
                  </button>
                  <button
                    onClick={(e) => handleLogin(e, "Listing Agent")}
                    className="btn agent-register-button"
                  >
                    Sign In As Listing Agent
                  </button>
                  {/* <img
                  src="/img/agent-register-devider.svg"
                  className="img-fluid agent-register-devider"
                  alt=""
                />
                <button
                  type="button"
                  className="btn agent-register-google-button"
                >
                  <img src="/img/google.png" alt="" /> Continue with Google
                </button> */}
                </form>
              </div>
              <div className="col-lg-6 px-0 d-none d-lg-block">
                <div className="agent-signin-image-conatiner"></div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default AgentRegister;
